import { FormattedDisplayName } from 'react-intl';

interface FormattedCountryProps {
  displayStyle?: 'short' | 'long';
  value: string;
}

export function FormattedCountry({ displayStyle = 'short', value }: FormattedCountryProps) {
  return <FormattedDisplayName style={displayStyle} type="region" value={value} />;
}
